import * as yup from 'yup';

export const basicInfoSchema = yup.object().shape({
  type: yup.string().required(),
  campaignName: yup.string().required(),
  campaignDescription: yup.string().required(),
});
